import { render, staticRenderFns } from "./PageCenter.vue?vue&type=template&id=32232af7&scoped=true"
import script from "./PageCenter.vue?vue&type=script&lang=js"
export * from "./PageCenter.vue?vue&type=script&lang=js"
import style0 from "./PageCenter.vue?vue&type=style&index=0&id=32232af7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32232af7",
  null
  
)

export default component.exports